var _g;
var _excluded = ["size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgPlanSilver = function SvgPlanSilver(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.845 17.074c0 6.93-5.618 12.548-12.547 12.548-6.93 0-12.548-5.618-12.548-12.548S9.367 4.527 16.298 4.527c6.93 0 12.547 5.617 12.547 12.547z",
    stroke: "#231F20",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.247 4.526s-2.102 7.4-11.572 9.822M16.348 4.526s2.102 7.4 11.572 9.822",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69 6.2c0-3.65 2.958-5.45 6.608-5.45 3.65 0 6.607 1.8 6.607 5.45M13 22.878c0 1.793 1.435 3.247 3.204 3.247 1.769 0 3.203-1.454 3.203-3.247H13zM14.849 15.632h2.688M12.631 19.674H9.189c-1.1 0-2-.9-2-2v-2.301c0-1.1.9-2 2-2h3.442c1.1 0 2 .9 2 2v2.3c0 1.1-.9 2-2 2z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.073 16.523a1.163 1.163 0 11-2.327 0 1.163 1.163 0 012.327 0",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.407 19.674h-3.442c-1.1 0-2-.9-2-2v-2.301c0-1.1.9-2 2-2h3.442c1.1 0 2 .9 2 2v2.3c0 1.1-.9 2-2 2z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.849 16.523a1.163 1.163 0 11-2.327 0 1.163 1.163 0 012.327 0",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.204 22.375s1.25.458 2 1.625M12.204 22.375s-1.25.458-2 1.625",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgPlanSilver;